import Base from '@studiometa/js-toolkit/abstracts/Base';
import gsap from 'gsap';
import useResize from '@studiometa/js-toolkit/services/resize';
import CanvasMenu from './CanvasMenu.js';

/**
 * Header
 * Handling openning / closing of menu and search
 */
class Header extends Base {
  /**
   * Header config
   */
  get config() {
    return {
      name: 'Header',
      components: {
        CanvasMenu,
      },
    };
  }

  /**
   * Moved hook
   */
  moved({ x, y }) {
    if (!this.isMoving) {
      return;
    }

    gsap.to(this.$children.CanvasMenu[0].$el, 1, {
      x,
      y,
      ease: 'power1.out',
    });
  }

  /**
   * Breakpoint
   */
  get breakpoint() {
    return useResize().props().breakpoint;
  }

  /**
   * Open Menu
   */
  onBurgerMenuClick() {
    this.$el.classList.add('is-menu-open');
    document.body.classList.add('overflow-hidden');
  }

  /**
   * Close menu
   */
  onCloseMenuClick() {
    this.$el.classList.remove('is-menu-open');
    document.body.classList.remove('overflow-hidden');
  }

  /**
   * Open Submenu
   * @param {object} e native event
   */
  onOpenSubmenuClick(e, index) {
    if (['xxs', 'xs', 's'].includes(this.breakpoint)) {
      e.preventDefault();
    }

    this.$refs.openSubmenu[index].classList.add('is-active');
    this.$el.classList.add('is-submenu-open');
  }

  /**
   * Close submenu
   */
  onCloseSubmenuClick() {
    this.$el.classList.remove('is-submenu-open');

    this.$refs.openSubmenu.forEach((element) => {
      element.classList.remove('is-active');
    });
  }

  /**
   * Open search
   */
  onOpenSearchClick() {
    this.$el.classList.toggle('is-search-open');
    this.$refs.searchInput.focus();
  }

  /**
   * Open search
   */
  onCloseSearchClick() {
    this.$el.classList.remove('is-search-open');
  }

  /**
   * OnMouseOver do animation
   */
  onSubmenuLinkMouseover(event, index) {
    this.$children.CanvasMenu[0].changeSlideAnimation(index);

    this.$refs.submenuLink.forEach((link, i) => {
      if (index !== i) {
        link.classList.add('text-grey-medium');
      }
    });
  }

  /**
   * Move and fade and enter
   */
  onSubmenuLinkMouseenter() {
    this.isMoving = true;
    this.$children.CanvasMenu[0].$el.classList.add('is-visible');
  }

  /**
   * Stop move and fade out on leave
   */
  onSubmenuLinkMouseleave() {
    this.isMoving = false;
    this.$children.CanvasMenu[0].$el.classList.remove('is-visible');
    this.$refs.submenuLink.forEach((link) => {
      link.classList.remove('text-grey-medium');
    });
  }
}

export default Header;
